// extracted by mini-css-extract-plugin
module.exports = {"illustration":"PageContent_illustration__Tuv5X","results":"PageContent_results__4RJhV"};